import React from 'react';
import { dayNamesFromMonday as dayNames } from '../../lib/format/Language';
import {
  formattedTimeFromAppointment,
  formatTimeForScreenReader,
  formatDateForScreenReader,
  getDayIndexStartedFromMonday
} from '../../util';
import { DefaultDateFormatter, intl } from '../../lib';
import { HBox } from '../layout';
import { Icon } from '../basic';

export interface AppointmentDateAndTimeProps {
  appointmentStart: string;
  classNameTitle?: string;
}

export function AppointmentDateAndTime({
  appointmentStart,
  classNameTitle,
  ...props
}: Readonly<AppointmentDateAndTimeProps>): React.JSX.Element {
  return (
    <HBox {...props} className="ehs-appointment-date-time date-info">
      <Icon
        iconName="shui_clock"
        className="date-icon color-black"
        aria-label={intl('common.date')}
      />
      <div className="date-info-text">
        <div className={classNameTitle}>
          <time
            dateTime={appointmentStart}
            aria-label={
              appointmentStart
                ? formatDateForScreenReader(new Date(appointmentStart))
                : undefined
            }
          >
            {appointmentStart && (
              <>
                {
                  dayNames[
                    getDayIndexStartedFromMonday(new Date(appointmentStart))
                  ]
                }
                ,{' '}
              </>
            )}
            {DefaultDateFormatter.formatDate(appointmentStart)}
          </time>
        </div>
        <time
          className="time-info"
          dateTime={appointmentStart}
          aria-label={
            appointmentStart
              ? formatTimeForScreenReader(new Date(appointmentStart))
              : undefined
          }
        >
          {formattedTimeFromAppointment(appointmentStart)}
        </time>
      </div>
    </HBox>
  );
}
